<template>
    <button
        class="
            bg-gray-200
            py-2
            px-6
            rounded-full
            font-sans
            hover:bg-gray-300
            active:bg-black active:text-white
            disabled:opacity-25
        "
        v-bind="$attrs"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: "AppButton",
};
</script>

<style scoped></style>
